import React from 'react';
import classnames from 'classnames';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import FaveControl from '../../../legos/FaveControl';
import CommentControl from '../../../legos/CommentControl';
import { getDeviationOwner } from '../../../../../utils/adoptables';
import UserIdentitySecondary from '../../../../../User/IdentitySecondary/UserIdentitySecondary';
import s from './BottomInfoBar.scss';
const BottomInfoBar = ({ deviation, className })=>{
    const { showCommentControl, showFaveControl } = useOverlayContext(deviation);
    const owner = getDeviationOwner(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, showFaveControl && /*#__PURE__*/ React.createElement(FaveControl, {
        deviation: deviation,
        className: s['stat']
    }), showCommentControl && /*#__PURE__*/ React.createElement(CommentControl, {
        deviation: deviation,
        className: s['stat']
    }), owner && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }, " "), /*#__PURE__*/ React.createElement(UserIdentitySecondary, {
        size: "small",
        user: owner
    })));
};
BottomInfoBar.displayName = 'BottomInfoBar';
export default BottomInfoBar;
